import React from 'react';
import SearchConditionStyled from './SearchConditionStyled';
import { useForm, Controller } from 'react-hook-form';
import {
  Box,
  FormControl,
  TextField,
  Button,
  useTheme,
} from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import ReplayIcon from '@material-ui/icons/Replay';
import SearchIcon from '@material-ui/icons/Search';
import ClearIcon from '@material-ui/icons/Clear';
import { useIntl } from 'umi';
import { createOid } from '@/utils/eventtracing';

const SearchCondition = (props) => {
  // const dispatch = useDispatch();
  const intl = useIntl();
  const { formatMessage } = intl;

  const { query } = props;
  const { handleSearch, restClick, searchRef } = props;
  const { memberCode, mobile } = query;
  const theme = useTheme();
  const {
    handleSubmit,
    control,
    reset,
    setValue,
    watch,
    // register,
  } = useForm({
    defaultValues: {
      memberCode,
      mobile,
    },
  });

  const resetData = () => {
    reset({
      memberCode: '',
      name: '',
      mobile: '',
    });
    setValue('memberCode', ' ');
    setValue('name', '');
    setValue('mobile', '');
    restClick && restClick();
  };

  const watchMemberCode = watch('memberCode');
  // const watchMemberName = watch('name');
  const watchMobileValue = watch('mobile');

  //查询
  const handleSubmitSuccess = (values) => {
    handleSearch(values);
  };

  return (
    <SearchConditionStyled theme={theme}>
      <form onSubmit={handleSubmit(handleSubmitSuccess)}>
        <div className="search-condition-wrap">
          <div className="card-content-wrap">
            <FormControl className="single-select">
              <Controller
                render={(rp) => (
                  <TextField
                    name="memberCode"
                    variant="standard"
                    // label="会员号"
                    label={formatMessage({
                      id: 'adjustment.members.n01.lbl01',
                    })}
                    value={rp.value}
                    onChange={(e) => {
                      setValue('memberCode', e.target.value);
                      // setMemberCodeValue(e.target.value);
                      return rp.value;
                    }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            className="clear-btn"
                            onClick={() => {
                              // setMemberCodeValue('');
                              setValue('memberCode', '');
                            }}
                            edge="end"
                          >
                            {watchMemberCode && (
                              <ClearIcon className="clear-icon" />
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                )}
                name="memberCode"
                variant="standard"
                control={control}
                id="basic"
                className="input"
                defaultValue={''}
              />
            </FormControl>
            {/* <FormControl className="single-select">
              <Controller
                render={(rp) => (
                  <TextField
                    name="name"
                    variant="standard"
                    label="会员姓名"
                    value={rp.value}
                    onChange={(e) => {
                      setValue('name', e.target.value);
                      // setMemberCodeValue(e.target.value);
                      return rp.value;
                    }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            className="clear-btn"
                            onClick={() => {
                              // setMemberCodeValue('');
                              setValue('name', '');
                            }}
                            edge="end"
                          >
                            {watchMemberName && (
                              <ClearIcon className="clear-icon" />
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                )}
                name="name"
                variant="standard"
                control={control}
                id="basic"
                className="input"
                defaultValue={''}
              />
            </FormControl> */}
            <FormControl className="single-select">
              <Controller
                render={(rp) => (
                  <TextField
                    name="mobile"
                    control={control}
                    id="basic"
                    variant="standard"
                    className="input"
                    // label="手机号"
                    label={formatMessage({
                      id: 'adjustment.members.n01.lbl03',
                    })}
                    value={rp.value}
                    defaultValue={''}
                    onChange={(e) => {
                      setValue('mobile', e.target.value);
                      // setMobileValue(e.target.value);
                    }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            className="clear-btn"
                            onClick={() => {
                              setValue('mobile', '');
                              // setMobileValue('');
                            }}
                            edge="end"
                          >
                            {watchMobileValue && (
                              <ClearIcon className="clear-icon" />
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                )}
                name="mobile"
                control={control}
                id="basic"
                variant="standard"
                className="input"
                // label="手机号"
                defaultValue={''}
              />
            </FormControl>
          </div>
          {/* 按钮 */}
          <Box className="button-group">
            <Button
              variant="contained"
              color="secondary"
              type="reset"
              className="reset"
              onClick={() => resetData()}
              startIcon={<ReplayIcon sx={{ width: '16px', height: '16px' }} />}
            >
              {/* 重置 */}
              {formatMessage({ id: 'comm.action.btn.06' })}
            </Button>
            <Button
              data-log={JSON.stringify({
                oid: createOid('ev'),
                events: ['_ev'],
                params: {
                  initUrl: window.location.origin + window.location.pathname,
                },
              })}
              ref={searchRef}
              variant="contained"
              type="submit"
              className="search"
              startIcon={<SearchIcon sx={{ width: '16px', height: '16px' }} />}
            >
              {/* 查询 */}
              {formatMessage({ id: 'comm.action.btn.01' })}
            </Button>
          </Box>
        </div>
      </form>
    </SearchConditionStyled>
  );
};

export default SearchCondition;
